import React, { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import Typography from 'src/common/components/Typography';
import PitchPageResource, { PitchPageResourceProps } from 'src/common/components/PitchPageResource';
import styles from './ResourceSection.module.scss';

export type ResourceSectionProps = {
  eyebrow?: string;
  title: string;
  text?: string;
  resourceListItems: PitchPageResourceProps[];
};

const ResourceSection: FC<ResourceSectionProps> = ({
  eyebrow,
  title,
  text,
  resourceListItems,
}) => (
  <div className={styles.root}>
    <div className={styles.header}>
      {eyebrow && (
        <div className={styles.eyebrow}>
          <Typography type="p" size="body-l" weight="bold">{eyebrow}</Typography>
        </div>
      )}
      <div className={styles.title}>
        <Typography
          type="h2"
          size="display-5"
          sizeFromBreakpointM="display-4"
        >
          {title}
        </Typography>
      </div>
      <div className={styles.text}>
        <Typography type="p" size="body-xl">{text}</Typography>
      </div>
    </div>
    <ul className={getClassNames(styles, 'resourceList', classNames(`itemCount-${resourceListItems.length}`))}>
      {resourceListItems.map((item) => (
        <PitchPageResource
          key={item.title}
          {...item}
        />
      ))}
    </ul>
  </div>
);

export default ResourceSection;
